import { render, staticRenderFns } from "./DutyInspectRecord.vue?vue&type=template&id=74ca3245&scoped=true"
import script from "./DutyInspectRecord.vue?vue&type=script&lang=js"
export * from "./DutyInspectRecord.vue?vue&type=script&lang=js"
import style0 from "./DutyInspectRecord.vue?vue&type=style&index=0&id=74ca3245&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ca3245",
  null
  
)

export default component.exports